import React, { useCallback, useMemo } from "react"
import { observer } from "mobx-react-lite"
import styled from "~/ui/styled"
import { useSafeAreaInsets } from "~/ui/safe-area"
import { ColumnFlex } from "~components/El"
import SwitchGroup from "../components/SwitchGroup"
import { SettingGroup, SettingItem } from "../types"
import { OnlineTimeSettingsScreenProps } from "./types"
import { useStores } from "~models"


const Container = styled.ScrollView`
  flex: 1;
  padding: 0 12px;
`

const getColumns = ({ option }: { option: any }): SettingGroup[] => {
  const groups: SettingGroup[] = [
    {
      title: "",
      contents: [
        {
          id: "online.status",
          type: "switch",
          title: "显示在线状态",
          content: "控制是否向好友显示您的在线状态",
          suffix: {
            type: "switch",
            value: option.onlineStatus,
            onChange: option.setOnlineStatus,
          },
          icon: "",
          iconColor: "",
          iconSize: 0,
          bg: ""
        }
      ]
    },
  ]

  if (option.onlineStatus) {
    groups.push({
      title: "显示规则",
      description: "选择在线状态的显示方式",
      contents: [{
          id: "online.showOnlineStatus",
          type: "navigate",
          title: "始终允许",
          content: "好友可以看到您的实时在线状态",
          suffix: {
            type: "switch",
            value: option.showOnlineStatus,
            onChange: option.setShowOnlineStatus,
          },
          icon: "szyx1",
          iconColor: "#07c160",
          iconSize: 16,
          bg: "rgba(7, 193, 96, 0.1)"
        },
        {
          id: "online.onlineTime",
          type: "switch",
          title: "最近活跃",
          content: "显示最后活跃时间，不显示实时状态",
          suffix: {
            type: "switch",
            value: option.onlineTime,
            onChange: option.setOnlineTime,
          },
          icon: "zjhy",
          iconColor: "#a507c1",
          iconSize: 16,
          bg: "rgba(165, 7, 193, 0.1)",
        }
      ]
    })
  }

  return groups
}

const OnlineTimeSettings: React.FC<OnlineTimeSettingsScreenProps> = () => {
  // const theme = useTheme()
  const insets = useSafeAreaInsets()
  const { walletStore, settingStore } = useStores()

  const option = useMemo(() => {
    const onlineOn = walletStore.show_online_status !== false
    const displayRuleIsAlways = walletStore.online_display_rule === 1
    const rule: 1 | 2 = displayRuleIsAlways ? 1 : 2

    return {
      onlineStatus: onlineOn,
      setOnlineStatus: (val: boolean) => {
        void settingStore.setOnlinePresenceSettings({
          show_online_status: val,
          online_display_rule: rule,
        })
      },

      showOnlineStatus: displayRuleIsAlways,
      setShowOnlineStatus: (val: boolean) => {
        if (!val) return
        void settingStore.setOnlinePresenceSettings({
          show_online_status: true,
          online_display_rule: 1,
        })
      },

      onlineTime: walletStore.online_display_rule !== 1,
      setOnlineTime: (val: boolean) => {
        if (!val) return
        void settingStore.setOnlinePresenceSettings({
          show_online_status: true,
          online_display_rule: 2,
        })
      },
    }
  }, [
    walletStore.show_online_status,
    walletStore.online_display_rule,
    settingStore,
  ])

  const onItemClick = useCallback((item: SettingItem) => {
    // console.log("press:", item.id)
  }, [])

  const columns = useMemo(() => getColumns({ option }), [option])

  return (
    <Container style={{ marginBottom: insets.bottom }}>
      <ColumnFlex padding="10px 0">
        {columns.map((item, index) => (
          <SwitchGroup
            key={index}
            item={item}
            onClick={onItemClick}
          />
        ))}
      </ColumnFlex>
    </Container>
  )
}

export default observer(OnlineTimeSettings)
